module.exports = {
  PENDING: 'pending',
  VALIDATED: 'validated',
  REJECTED: 'rejected',
};
